"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _icons = require("../../icons");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableHeaderButton = function TableHeaderButton(_ref) {
  var children = _ref.children,
      justifyContent = _ref.justifyContent,
      onClick = _ref.onClick,
      sortDirection = _ref.sortDirection,
      spacing = _ref.spacing,
      titleText = _ref.titleText,
      textAlign = _ref.textAlign;

  // Be used to indicate if button is focused by tab press.
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFocusedByTab = _useState2[0],
      setIsFocusedByTab = _useState2[1];

  var SortingIcon;

  if (sortDirection === _interfaces.SortDirection.Ascending) {
    SortingIcon = _icons.IconSortAscending;
  } else if (sortDirection === _interfaces.SortDirection.Descending) {
    SortingIcon = _icons.IconSortDescending;
  } else {
    SortingIcon = _icons.IconSort;
  }

  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === _utils.EventKeys.TAB) {
      setIsFocusedByTab(true);
    }
  };

  var handleBlur = function handleBlur() {
    setIsFocusedByTab(false);
  };

  return (0, _core.jsx)(_helperComponents.TableHeaderButtonBase, {
    title: titleText,
    onClick: onClick,
    isFocusedByTab: isFocusedByTab,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur
  }, (0, _core.jsx)(_helperComponents.TableHeaderButtonContent, {
    spacing: spacing,
    alignItems: "center",
    justifyContent: justifyContent,
    textAlign: textAlign,
    gridGap: "S100"
  }, !!children && children, (0, _core.jsx)(SortingIcon, {
    "aria-hidden": true,
    color: _constants.TABLE_HEADER_BUTTON_SORT_ICON_COLOR,
    size: _icons.IconSize.ExtraSmall
  })));
};

var _default = TableHeaderButton;
exports.default = _default;